export default __webpack_public_path__ + "static/media/arts.0f433c6d.svg";